export default __webpack_public_path__ + "static/media/4Y.ae547a47.png";